import '../App.css';
import NavBar from './navbar';
import NavMenu from './navmenu';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown, faCaretUp, faCircleCheck, faSync, faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import * as UI from '../slices/uiSlice';
import * as Cases from '../slices/casesSlice';
import * as Forms from '../slices/formsSlice';
import { useAppDispatch, useAppSelector } from '../slices';
import { useNavigate } from 'react-router';
import { AnyAction } from 'redux';
import { useEffect, useState } from 'react';
import { doFormOnChange, getCurrentFormattedDate, getFormValidWithId, getFormValueWithId, getJSONWithFormValues, getUkDate, validateForm } from '../utilities';
import leading_the_way from '../assets/Leading_The_Way_Conveyancing.svg';
import hub_logo from '../assets/Main_Hub_Icon_Large.svg';
import icon_chase from '../assets/Chase_Icon.svg';
import icon_email from '../assets/Email_White.svg';
import icon_why from '../assets/Ask_Why_Icon.svg';
import icon_intro_actions from '../assets/Introducer_Icon.svg';
import OpenCaseIconBlue from '../assets/open-case-icon-blue.svg';
import CaseDetailsIconBlue from '../assets/case-details-icon-blue.svg';
import ActionsIcon from '../assets/actions-icon.svg';
import FormsAndReportsIconBlue from '../assets/forms-and-reports-icon-blue.svg';
import MeetTheTeamIconBlue from '../assets/meet-the-team-icon-blue.svg';
import WishlistIconBlue from '../assets/wishlist-icon-blue.svg';

const Actions = () => {
	const cases = useAppSelector(state => state.cases);
	const user = useAppSelector(state => state.user);
	const forms = useAppSelector(state => state.forms);
	const navigate = useNavigate();
	const dispatch = useAppDispatch();
	const [page, setPage] = useState('Note');
	const [tab, setTab] = useState('Chasers');

	const handleScroll = () => {
		dispatch((UI.closeMenu()) as unknown as AnyAction);
	};

	const openCase = () => {
		navigate('/case');
	}

	const openCaseDetails = () => {
		navigate('/case-details');
	}

	const openActions = () => {
		navigate('/actions');
	}

	const openHistory = () => {
		navigate('/historylist');
	}

	const openTeam = () => {
		navigate('/team');
	}

	const setPageAndTab = (p: string, t: string) => {
		setPage(p);
		setTab(t);
	}

	const actionOnClickCCE = (item: Cases.sortType) => {
		dispatch(Cases.setSortTypeCCE(item));
	}

	const actionOnClickWWC = (item: Cases.sortType) => {
		dispatch(Cases.setSortTypeWWC(item));
	}

	const actionOnClickIA = (item: Cases.sortType) => {
		dispatch(Cases.setSortTypeIA(item));
	}

	function compareActionsRaised(a: Cases.caseActionsState, b: Cases.caseActionsState) {
		var partsa = a.raised.split("/");
		var partsb = b.raised.split("/");
		var dta = new Date(parseInt(partsa[2]), parseInt(partsa[1]) - 1, parseInt(partsa[0]));
		var dtb = new Date(parseInt(partsb[2]), parseInt(partsb[1]) - 1, parseInt(partsb[0]));

		if (dta < dtb) {
			return -1;
		}
		if (dta > dtb) {
			return 1;
		}
		return 0;
	}
	function compareActionsType(a: Cases.caseActionsState, b: Cases.caseActionsState) {
		if (a.type < b.type) {
			return -1;
		}
		if (a.type > b.type) {
			return 1;
		}
		return 0;
	}
	function compareActionsWho(a: Cases.caseActionsState, b: Cases.caseActionsState) {
		const whoa = (a.reason === null ? '' : a.reason);
		const whob = (b.reason === null ? '' : b.reason);

		if (whoa.trim().toLowerCase() < whob.trim().toLowerCase()) {
			return -1;
		}
		if (whoa.trim().toLowerCase() > whob.trim().toLowerCase()) {
			return 1;
		}
		return 0;
	}
	function compareActionsWhy(a: Cases.caseActionsState, b: Cases.caseActionsState) {
		const whya = (a.notes === null ? '' : a.notes);
		const whyb = (b.notes === null ? '' : b.notes);

		if (whya.trim().toLowerCase() < whyb.trim().toLowerCase()) {
			return -1;
		}
		if (whya.trim().toLowerCase() > whyb.trim().toLowerCase()) {
			return 1;
		}
		return 0;
	}
	function compareActionsResponded(a: Cases.caseActionsState, b: Cases.caseActionsState) {
		var dta = Date.parse(a.responded);
		var dtb = Date.parse(b.responded);

		if (dta < dtb) {
			return -1;
		}
		if (dta > dtb) {
			return 1;
		}
		return 0;
	}
	function compareActionsResponse(a: Cases.caseActionsState, b: Cases.caseActionsState) {
		const respa = (a.response === null ? '' : a.response);
		const respb = (b.response === null ? '' : b.response);

		if (respa.trim().toLowerCase() < respb.trim().toLowerCase()) {
			return -1;
		}
		if (respa.trim().toLowerCase() > respb.trim().toLowerCase()) {
			return 1;
		}
		return 0;
	}
	function compareActionsStatus(a: Cases.caseActionsState, b: Cases.caseActionsState) {
		var sa = (a.responded === '1900-01-01 00:00:00.000' ? 'A' : 'B');
		var sb = (b.responded === '1900-01-01 00:00:00.000' ? 'A' : 'B');

		if (sa < sb) {
			return -1;
		}
		if (sa > sb) {
			return 1;
		}
		return 0;
	}

	const getActions = (type: string): Cases.actionItemState[] => {
		let actions: Cases.actionItemState[] = [];
		for (const a of cases.actions.common) {
			if (a.type === type) {
				actions.push(a);
			}
		}
		if (cases.case.type === 'P') {
			for (const a of cases.actions.P) {
				if (a.type === type) {
					actions.push(a);
				}
			}
		}
		if (cases.case.type === 'R') {
			for (const a of cases.actions.R) {
				if (a.type === type) {
					actions.push(a);
				}
			}
		}
		if (cases.case.type === 'S') {
			for (const a of cases.actions.S) {
				if (a.type === type) {
					actions.push(a);
				}
			}
		}
		return actions;
	}
	const getChaseActions = (): Cases.caseActionsState[] => {
		let actions: Cases.caseActionsState[] = [];
		for (const a of cases.case.actions) {
			if (a.type === 'CHASE' || a.type === 'CALL' || a.type === 'EMAIL' || a.type === 'NOTE') {
				actions.push(a);
			}
		}
		switch (cases.sortTypeCCE.type) {
			case 'Raised':
				actions.sort(compareActionsRaised);
				break;
			case 'Type':
				actions.sort(compareActionsType);
				break;
			case 'Who':
				actions.sort(compareActionsWho);
				break;
			case 'Why':
				actions.sort(compareActionsWhy);
				break;
			case 'Responded':
				actions.sort(compareActionsResponded);
				break;
			case 'Response':
				actions.sort(compareActionsResponse);
				break;
			case 'Status':
				actions.sort(compareActionsStatus);
				break;
		}
		if (cases.sortTypeCCE.reverse) {
			actions.reverse();
		}
		return actions;
	}
	const getPushActions = (): Cases.caseActionsState[] => {
		let actions: Cases.caseActionsState[] = [];
		for (const a of cases.case.actions) {
			if (a.type === 'PUSH') {
				actions.push(a);
			}
		}
		switch (cases.sortTypeWWC.type) {
			case 'Raised':
				actions.sort(compareActionsRaised);
				break;
			case 'Type':
				actions.sort(compareActionsType);
				break;
			case 'Who':
				actions.sort(compareActionsWho);
				break;
			case 'Why':
				actions.sort(compareActionsWhy);
				break;
			case 'Responded':
				actions.sort(compareActionsResponded);
				break;
			case 'Response':
				actions.sort(compareActionsResponse);
				break;
			case 'Status':
				actions.sort(compareActionsStatus);
				break;
		}
		if (cases.sortTypeWWC.reverse) {
			actions.reverse();
		}
		return actions;
	}
	const getIntroActions = (): Cases.caseActionsState[] => {
		let actions: Cases.caseActionsState[] = [];
		for (const a of cases.case.actions) {
			if (a.type === 'INTRO') {
				actions.push(a);
			}
		}
		switch (cases.sortTypeIA.type) {
			case 'Raised':
				actions.sort(compareActionsRaised);
				break;
			case 'Who':
				actions.sort(compareActionsWho);
				break;
			case 'Why':
				actions.sort(compareActionsWhy);
				break;
			case 'Responded':
				actions.sort(compareActionsResponded);
				break;
			case 'Response':
				actions.sort(compareActionsResponse);
				break;
			case 'Status':
				actions.sort(compareActionsStatus);
				break;
		}
		if (cases.sortTypeIA.reverse) {
			actions.reverse();
		}
		return actions;
	}

	const noteCase = () => {
		if (validateForm('NOTE', 'NOTE')) {
			dispatch(Cases.setChasing(true));
			const json = getJSONWithFormValues('NOTE');
			const data = JSON.parse(json);

			const state: Cases.chaseCaseState = {
				caseno: cases.case.caseno,
				id: user.id,
				usertype: user.type,
				token: user.token,
				casetype: cases.case.casetype,
				handler: (cases.case.details ? cases.case.details.handler : ''),
				type: 'NOTE',
				reason: '',
				reasoncode: '',
				actionby: '',
				notes: data.chase_notes.val
			}
			dispatch(Cases.chaseCase(state) as unknown as AnyAction).then(() => {
				dispatch(Forms.removeFormWithId('NOTE'));
				setTab('Chasers');
			});
		}
	}

	const chaseCase = () => {
		if (validateForm('CHASE', 'CHASE')) {
			dispatch(Cases.setChasing(true));
			const json = getJSONWithFormValues('CHASE');
			const data = JSON.parse(json);

			const selt: HTMLSelectElement = document.getElementById('chase_type') as HTMLSelectElement;
			const type = selt.options[selt.selectedIndex].value;
			const sel: HTMLSelectElement = document.getElementById('chase_reason') as HTMLSelectElement;
			const reason = sel.options[sel.selectedIndex].text;

			const state: Cases.chaseCaseState = {
				caseno: cases.case.caseno,
				id: user.id,
				usertype: user.type,
				token: user.token,
				casetype: cases.case.casetype,
				handler: (cases.case.details ? cases.case.details.handler : ''),
				type: type,
				reason: reason,
				reasoncode: data.chase_reason.val,
				actionby: '',
				notes: data.chase_notes.val
			}
			dispatch(Cases.chaseCase(state) as unknown as AnyAction).then(() => {
				dispatch(Forms.removeFormWithId('CHASE'));
				setTab('Chasers');
			});
		}
	}
	const callCase = () => {
		if (validateForm('CALL', 'CALL')) {
			dispatch(Cases.setCalling(true));
			const json = getJSONWithFormValues('CALL');
			const data = JSON.parse(json);

			const sel: HTMLSelectElement = document.getElementById('call_recipient') as HTMLSelectElement;
			const reason = sel.options[sel.selectedIndex].text;

			const state: Cases.chaseCaseState = {
				caseno: cases.case.caseno,
				id: user.id,
				usertype: user.type,
				token: user.token,
				casetype: cases.case.casetype,
				handler: (cases.case.details ? cases.case.details.handler : ''),
				type: 'CALL',
				reason: reason,
				reasoncode: data.call_recipient.val,
				actionby: '',
				notes: data.call_notes.val
			}
			dispatch(Cases.callCase(state) as unknown as AnyAction).then(() => {
				dispatch(Forms.removeFormWithId('CALL'));
				setTab('Chasers');
			});
		}
	}
	const emailCase = () => {
		if (validateForm('EMAIL', 'EMAIL')) {
			dispatch(Cases.setEmailing(true));
			const json = getJSONWithFormValues('EMAIL');
			const data = JSON.parse(json);

			const sel: HTMLSelectElement = document.getElementById('email_recipient') as HTMLSelectElement;
			const reason = sel.options[sel.selectedIndex].text;

			const state: Cases.chaseCaseState = {
				caseno: cases.case.caseno,
				id: user.id,
				usertype: user.type,
				token: user.token,
				casetype: cases.case.casetype,
				handler: (cases.case.details ? cases.case.details.handler : ''),
				type: 'EMAIL',
				reason: reason,
				reasoncode: data.email_recipient.val,
				actionby: '',
				notes: data.call_notes.val
			}
			dispatch(Cases.callCase(state) as unknown as AnyAction).then(() => {
				dispatch(Forms.removeFormWithId('CALL'));
				setTab('Chasers');
			});
		}
	}
	const pushCase = () => {
		if (validateForm('PUSH', 'PUSH')) {
			dispatch(Cases.setPushing(true));
			const json = getJSONWithFormValues('PUSH');
			const data = JSON.parse(json);

			const sel: HTMLSelectElement = document.getElementById('push_reason') as HTMLSelectElement;
			const reason = sel.options[sel.selectedIndex].text;

			const state: Cases.chaseCaseState = {
				caseno: cases.case.caseno,
				id: user.id,
				usertype: user.type,
				token: user.token,
				casetype: cases.case.casetype,
				handler: (cases.case.details ? cases.case.details.handler : ''),
				type: 'PUSH',
				reason: reason,
				reasoncode: data.push_reason.val,
				actionby: '',
				notes: ''
			}
			dispatch(Cases.pushCase(state) as unknown as AnyAction).then(() => {
				dispatch(Forms.removeFormWithId('PUSH'));
				setTab('Push');
			});
		}
	}

	const wishList = () => {
		if (cases.case.details && cases.case.details.wishlisted) {
			dispatch(UI.setWishlistEditPopup({ visible: true, caseno: cases.case.caseno, casetype: cases.case.type }));
		} else {
			dispatch(UI.setWishlistPopup({ visible: true, caseno: cases.case.caseno, casetype: cases.case.type }));
		}
	}

	const selectIntroAction = (item: Cases.caseActionsState) => {
		setPage('Introducer');
		dispatch(Cases.setSelectedAction(item));
	}

	const sendIntroAction = () => {
		if (validateForm('INTRO', 'INTRO')) {
			dispatch(Cases.setSendingIntroResponse(true));
			const json = getJSONWithFormValues('INTRO');
			const data = JSON.parse(json);

			const state: Cases.sendIntroActionState = {
				caseno: cases.case.caseno,
				refer: user.id,
				usertype: user.type,
				token: user.token,
				casetype: cases.case.casetype,
				handler: (cases.case.details ? cases.case.details.handler : ''),
				id: (cases.case.selectedAction ? cases.case.selectedAction.id : ''),
				response: data.intro_response.val
			}
			dispatch(Cases.sendActionResponse(state) as unknown as AnyAction).then(() => {
				dispatch(Forms.removeFormWithId('INTRO'));
			});
		}
	}

	const handleMarkAsRead = (clickedActionId: string) => {
		const updatedActions = cases.case.actions.map((item: Cases.caseActionsState) => {
			if (item.id === clickedActionId) {
				return {
					...item,
					readDate: getCurrentFormattedDate(),
				};
			}
			return item;
		});

		const updatedUnviewActions = cases.case.details?.unviewActions?.filter((item) => item !== clickedActionId) || [];
		const updatedDetails = { ...cases.case.details, unviewActions: updatedUnviewActions };

		const updatedCase = { ...cases.case, actions: updatedActions, details: updatedDetails };
		const state = { id: clickedActionId, readDate: getCurrentFormattedDate() };

		dispatch(Cases.setLoaded(false));
		dispatch(Cases.updateCaseAction(state) as unknown as AnyAction).then(() => {
			dispatch(Cases.setCase(updatedCase));
			dispatch(Cases.setLoaded(true));
		});
	};

	useEffect(() => {
		dispatch(Forms.removeFormWithId('NOTE'));
		dispatch(Forms.removeFormWithId('CHASE'));
		dispatch(Forms.removeFormWithId('CALL'));
		dispatch(Forms.removeFormWithId('EMAIL'));
		dispatch(Forms.removeFormWithId('PUSH'));
		dispatch(Forms.removeFormWithId('INTRO'));
		dispatch(Cases.setSelectedAction(null));
	}, [tab, dispatch]);

	useEffect(() => {
		if (!cases.case.caseno) {
			navigate('/hub');
		}
	}, [])
	var isMac = navigator.platform.toUpperCase().indexOf('MAC')>=0;

	return (
		<div className="Home" style={{ position: 'relative' }}>
			<div style={{ position: 'absolute', top: 96, left: 0, right: 0, bottom: 80 }}>
				<div className='OrangeBand'>
					<div style={{ marginLeft: 'calc(10% + 144px)', marginRight: '10%', width: 'calc(80% - 144px)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
						<div style={{ display: 'flex', alignItems: 'center' }}>
							<img style={{ width: 96, marginRight: 8 }} src={hub_logo} alt='Hub-Logo' />
							<div style={{ marginLeft: 24 }}>
								<div style={{ fontFamily: 'OpenSans-Bold', fontSize: 36, marginBottom: 12, whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>View Case {cases.case.caseno}</div>
							</div>
						</div>
					</div>
				</div>
				<div className="row100 topButtonContainer" style={{ justifyContent: 'start', alignItems: 'end', position: 'absolute', top: '150px', left: '2%', zIndex: 995 }}>
					<div className='buttonPurpleSecondary' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden' }} onClick={() => openCase()}>
						<div style={{ display: 'flex', alignItems: 'center', minWidth: '35px' }}>
							<img style={{ width: 20, height: 20, marginRight: 8 }} src={OpenCaseIconBlue} alt='Milestones-Icon' />
							<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Milestones</div>
						</div>
						<div style={{ width: 32, display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
							{cases.isOpeningActions &&
								<FontAwesomeIcon className='fa-spin' style={{ fontSize: 18, marginRight: 8 }} icon={faSync} />
							}
						</div>
					</div>
					<div className='buttonPurpleSecondary' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden' }} onClick={() => openCaseDetails()}>
						<div style={{ display: 'flex', alignItems: 'center', minWidth: '40px' }}>
							<img style={{ width: 20, height: 20, marginRight: 8 }} src={CaseDetailsIconBlue} alt='CaseDetails-Icon' />
							<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Case Details</div>
						</div>
						<div style={{ width: 32, display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
							{cases.isOpeningActions &&
								<FontAwesomeIcon className='fa-spin' style={{ fontSize: 18, marginRight: 8 }} icon={faSync} />
							}
						</div>
					</div>
					<div className='buttonPurple' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden' }} onClick={() => openActions()}>
						<div style={{ display: 'flex', alignItems: 'center', minWidth: '40px' }}>
							<img style={{ width: 20, height: 20, marginRight: 8 }} src={ActionsIcon} alt='Actions-Icon' />
							<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden', position: 'relative' }}>Actions</div>
							{cases.case.details && cases.case.details.unviewActions.length > 0 && <div style={{ height: '19px', width: '19px', marginLeft: '10px', backgroundColor: 'red', borderRadius: '50%', color: '#FFFFFF', fontSize: '10px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>{cases.case.details.unviewActions.length}</div>}
						</div>
						<div style={{ width: 32, display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
							{cases.isOpeningActions &&
								<FontAwesomeIcon className='fa-spin' style={{ fontSize: 18, marginRight: 8 }} icon={faSync} />
							}
						</div>
					</div>
					<div className='buttonPurpleSecondary' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden' }} onClick={() => openHistory()}>
						<div style={{ display: 'flex', alignItems: 'center', minWidth: '55px' }}>
							<img style={{ width: 20, height: 20, marginRight: 8 }} src={FormsAndReportsIconBlue} alt='Forms&Reports-Icon' />
							<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Forms & Reports</div>
						</div>
						<div style={{ width: 32, display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
							{cases.isOpeningActions &&
								<FontAwesomeIcon className='fa-spin' style={{ fontSize: 18, marginRight: 8 }} icon={faSync} />
							}
						</div>
					</div>
					<div className='buttonPurpleSecondary' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden' }} onClick={() => openTeam()}>
						<div style={{ display: 'flex', alignItems: 'center', minWidth: '45px' }}>
							<img style={{ width: 20, height: 20, marginRight: 8 }} src={MeetTheTeamIconBlue} alt='Team-Icon' />
							<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Meet the Team</div>
						</div>
						<div style={{ width: 32, display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
							{cases.isOpeningTeam &&
								<FontAwesomeIcon className='fa-spin' style={{ fontSize: 18, marginRight: 8 }} icon={faSync} />
							}
						</div>
					</div>
					<div className={(cases.case.details?.wishlisted ? 'buttonGreenRounded' : 'buttonPurpleSecondary')} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden' }} onClick={() => wishList()}>
						<div style={{ display: 'flex', alignItems: 'center', minWidth: '35px' }}>
							<img style={{ width: 20, height: 20, marginRight: 8 }} src={WishlistIconBlue} alt='Wishlist-Icon' />
							<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Wishlist{(cases.case.details?.wishlisted ? ' - ' + cases.case.details.wishlisted : '')}</div>
						</div>
						<div style={{ width: 32, display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
							{cases.isWishlisting &&
								<FontAwesomeIcon className='fa-spin' style={{ fontSize: 18, marginRight: 8 }} icon={faSync} />
							}
						</div>
					</div>
				</div>
				<div className='actionButtonsLeft' style={{ display: 'flex', maxWidth: 960, margin: '38px auto auto 2%', marginTop: 78, color: 'black' }}>
					<div style={{ display: 'flex', flexDirection: 'column' }}>
						<div className='buttonBlueBigRounded' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden', flex: '0 0 40px' }} onClick={() => setPageAndTab('Note', 'Chasers')}>
							<div style={{ display: 'flex', alignItems: 'center' }}>
								<img style={{ width: 24, height: 24, marginLeft: 12, marginRight: 12 }} src={icon_email} alt='Email-Icon' />
								<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Send PLS a Note...</div>
							</div>
						</div>
						<div className='buttonBlueBigRounded' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden', flex: '0 0 40px' }} onClick={() => setPageAndTab('Chase', 'Chasers')}>
							<div style={{ display: 'flex', alignItems: 'center' }}>
								<img style={{ width: 24, height: 24, marginLeft: 12, marginRight: 12 }} src={icon_chase} alt='Chase-Icon' />
								<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Ask PLS to Chase...</div>
							</div>
						</div>
						<div className='buttonBlueBigRounded' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden', flex: '0 0 40px' }} onClick={() => setPageAndTab('Push', 'Push')}>
							<div style={{ display: 'flex', alignItems: 'center' }}>
								<img style={{ width: 24, height: 24, marginLeft: 12, marginRight: 12 }} src={icon_why} alt='Why-Icon' />
								<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Ask PLS why we can’t...</div>
							</div>
						</div>
						<div className='buttonBlueBigRounded' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden', flex: '0 0 40px' }} onClick={() => setPageAndTab('Introducer', 'Introducer')}>
							<div style={{ display: 'flex', alignItems: 'center' }}>
								<img style={{ width: 24, height: 24, marginLeft: 12, marginRight: 12 }} src={icon_intro_actions} alt='Actions-Icon' />
								<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Introducer Actions...</div>
							</div>
						</div>
					</div>
					{page === 'Note' &&
						<div id='NOTE' style={{ flexGrow: 1, marginLeft: 64 }}>
							<div style={{ display: 'flex', margin: 4, justifyContent: 'flex-start' }}>
								<div style={{ display: 'flex', alignItems: 'center', fontSize: 15, fontFamily: 'OpenSans-Bold' }}>
									<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Send PLS a Note...</div>
								</div>
							</div>
							<div style={{ display: 'flex', margin: 4, fontSize: 13, alignItems: 'top' }}>
								<div className='row25' style={{ display: 'flex', alignItems: 'top', justifyContent: 'start' }}>Note:</div>
								<div className='row75'>
									<textarea data-form-id={'NOTE'} rows={4} data-valid-type="*" className={getFormValidWithId('NOTE', "chase_notes") ? undefined : 'error'} value={getFormValueWithId('NOTE', "chase_notes")} name='chase_notes' id='chase_notes' onChange={(e) => doFormOnChange(e)} />
								</div>
							</div>
							<div style={{ display: 'flex', margin: 4 }}>
								<div className='row25'></div>
								<div className='row75' style={{ display: 'inherit' }}>
									<div className='buttonGreen' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden' }} onClick={() => noteCase()}>
										<div style={{ display: 'flex' }}>
											<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden', marginLeft: 24, cursor: 'pointer' }}>Submit</div>
										</div>
										<div style={{ width: 32, display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
											{cases.isChasing &&
												<FontAwesomeIcon className='fa-spin' style={{ fontSize: 18, marginRight: 8 }} icon={faSync} />
											}
										</div>
									</div>
								</div>
							</div>
						</div>
					}
					{page === 'Chase' &&
						<div id='CHASE' style={{ flexGrow: 1, marginLeft: 64 }}>
							<div style={{ display: 'flex', margin: 4, justifyContent: 'flex-start' }}>
								<div style={{ display: 'flex', alignItems: 'center', fontSize: 15, fontFamily: 'OpenSans-Bold' }}>
									<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Ask PLS to Chase...</div>
								</div>
							</div>
							<div style={{ display: 'flex', margin: 4, fontSize: 13, alignItems: 'top' }}>
								<div className='row25' style={{ display: 'flex', alignItems: 'top', justifyContent: 'start', marginTop: '2px' }}>Type:</div>
								<div className='row75'>
									<select data-form-id={'CHASE'} data-valid-type="*" className={getFormValidWithId('CHASE', "chase_type") ? undefined : 'error'} value={getFormValueWithId('CHASE', "chase_type")} name='chase_type' id='chase_type' onChange={(e) => doFormOnChange(e)}>
										<option value=''>Please Select...</option>
										<option value='CHASE'>Chase</option>
										<option value='CALL'>Call</option>
										<option value='EMAIL'>Email</option>
									</select>
								</div>
							</div>
							<div style={{ display: 'flex', margin: 4, fontSize: 13, alignItems: 'top' }}>
								<div className='row25' style={{ display: 'flex', alignItems: 'top', justifyContent: 'start', marginTop: '2px' }}>Who to Chase?:</div>
								<div className='row75'>
									<select data-form-id={'CHASE'} data-valid-type="*" className={getFormValidWithId('CHASE', "chase_reason") ? undefined : 'error'} value={getFormValueWithId('CHASE', "chase_reason")} name='chase_reason' id='chase_reason' onChange={(e) => doFormOnChange(e)}>
										<option value=''>Please Select...</option>
										{(getActions('CHASE') || []).map((item: Cases.actionItemState) => {
											return (
												<option key={item.reasoncode} value={item.reasoncode}> {item.reason} ({item.reasoncode})</option>
											)
										})}
									</select>
								</div>
							</div>
							<div style={{ display: 'flex', margin: 4, fontSize: 13, alignItems: 'top' }}>
								<div className='row25' style={{ display: 'flex', alignItems: 'top', justifyContent: 'start', marginTop: '2px' }}>What are we Chasing?:</div>
								<div className='row75'>
									<textarea data-form-id={'CHASE'} rows={4} data-valid-type="*" className={getFormValidWithId('CHASE', "chase_notes") ? undefined : 'error'} value={getFormValueWithId('CHASE', "chase_notes")} name='chase_notes' id='chase_notes' onChange={(e) => doFormOnChange(e)} />
								</div>
							</div>
							<div style={{ display: 'flex', margin: 4 }}>
								<div className='row25'></div>
								<div className='row75' style={{ display: 'inherit' }}>
									<div className='buttonGreen' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden' }} onClick={() => chaseCase()}>
										<div style={{ display: 'flex' }}>
											<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden', marginLeft: 24, cursor: 'pointer' }}>Submit</div>
										</div>
										<div style={{ width: 32, display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
											{cases.isChasing &&
												<FontAwesomeIcon className='fa-spin' style={{ fontSize: 18, marginRight: 8 }} icon={faSync} />
											}
										</div>
									</div>
								</div>
							</div>
						</div>
					}
					{page === 'Call' &&
						<div id='CALL' style={{ flexGrow: 1, marginLeft: 64 }}>
							<div style={{ display: 'flex', margin: 4, justifyContent: 'flex-start' }}>
								<div style={{ display: 'flex', alignItems: 'center', fontSize: 15, fontFamily: 'OpenSans-Bold' }}>
									<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Ask PLS to Call...</div>
								</div>
							</div>
							<div style={{ display: 'flex', margin: 4, fontSize: 13, alignItems: 'top' }}>
								<div className='row25' style={{ display: 'flex', alignItems: 'top', justifyContent: 'start' }}>Who to Call?:</div>
								<div className='row75'>
									<select data-form-id={'CALL'} data-valid-type="*" className={getFormValidWithId('CALL', "call_recipient") ? undefined : 'error'} value={getFormValueWithId('CALL', "call_recipient")} name='call_recipient' id='call_recipient' onChange={(e) => doFormOnChange(e)}>
										<option value=''>Please Select...</option>
										{(getActions('CALL') || []).map((item: Cases.actionItemState) => {
											return (
												<option key={item.reasoncode} value={item.reasoncode}> {item.reason} ({item.reasoncode})</option>
											)
										})}
									</select>
								</div>
							</div>
							<div style={{ display: 'flex', margin: 4, fontSize: 13, alignItems: 'top' }}>
								<div className='row25' style={{ display: 'flex', alignItems: 'top', justifyContent: 'start' }}>Why are we Calling?:</div>
								<div className='row75'>
									<textarea data-form-id={'CALL'} rows={4} data-valid-type="*" className={getFormValidWithId('CALL', "call_notes") ? undefined : 'error'} value={getFormValueWithId('CALL', "call_notes")} name='call_notes' id='call_notes' onChange={(e) => doFormOnChange(e)} />
								</div>
							</div>
							<div style={{ display: 'flex', margin: 4 }}>
								<div className='row25'></div>
								<div className='row75' style={{ display: 'inherit' }}>
									<div className='buttonGreen' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden' }} onClick={() => callCase()}>
										<div style={{ display: 'flex' }}>
											<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden', marginLeft: 24, cursor: 'pointer' }}>Submit</div>
										</div>
										<div style={{ width: 32, display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
											{cases.isCalling &&
												<FontAwesomeIcon className='fa-spin' style={{ fontSize: 18, marginRight: 8 }} icon={faSync} />
											}
										</div>
									</div>
								</div>
							</div>
						</div>
					}
					{page === 'Email' &&
						<div id='EMAIL' style={{ flexGrow: 1, marginLeft: 64 }}>
							<div style={{ display: 'flex', margin: 4, justifyContent: 'flex-start' }}>
								<div style={{ display: 'flex', alignItems: 'top', fontSize: 15, fontFamily: 'OpenSans-Bold' }}>
									<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Ask PLS to Email...</div>
								</div>
							</div>
							<div style={{ display: 'flex', margin: 4, fontSize: 13, alignItems: 'top' }}>
								<div className='row25' style={{ display: 'flex', alignItems: 'top', justifyContent: 'start' }}>Who to Email?:</div>
								<div className='row75'>
									<select data-form-id={'EMAIL'} data-valid-type="*" className={getFormValidWithId('EMAIL', "email_recipient") ? undefined : 'error'} value={getFormValueWithId('EMAIL', "email_recipient")} name='email_recipient' id='email_recipient' onChange={(e) => doFormOnChange(e)}>
										<option value=''>Please Select...</option>
										{(getActions('EMAIL') || []).map((item: Cases.actionItemState) => {
											return (
												<option key={item.reasoncode} value={item.reasoncode}> {item.reason} ({item.reasoncode})</option>
											)
										})}
									</select>
								</div>
							</div>
							<div style={{ display: 'flex', margin: 4, fontSize: 13, alignItems: 'top' }}>
								<div className='row25' style={{ display: 'flex', alignItems: 'top', justifyContent: 'start' }}>Why are we Emailing?:</div>
								<div className='row75'>
									<textarea data-form-id={'EMAIL'} rows={4} data-valid-type="*" className={getFormValidWithId('EMAIL', "call_notes") ? undefined : 'error'} value={getFormValueWithId('EMAIL', "call_notes")} name='call_notes' id='call_notes' onChange={(e) => doFormOnChange(e)} />
								</div>
							</div>
							<div style={{ display: 'flex', margin: 4 }}>
								<div className='row25'></div>
								<div className='row75' style={{ display: 'inherit' }}>
									<div className='buttonGreen' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden' }} onClick={() => emailCase()}>
										<div style={{ display: 'flex' }}>
											<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden', marginLeft: 24, cursor: 'pointer' }}>Submit</div>
										</div>
										<div style={{ width: 32, display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
											{cases.isCalling &&
												<FontAwesomeIcon className='fa-spin' style={{ fontSize: 18, marginRight: 8 }} icon={faSync} />
											}
										</div>
									</div>
								</div>
							</div>
						</div>
					}
					{tab === 'Chasers' &&
						<>
							<div className='actionTableContainer' style={{ position: 'absolute', top: 468, left: '2%', right: 0, height: 80, display: 'flex', flexDirection: 'column', gap: '10px', paddingRight: '15px' }}>
								<div style={{ display: 'flex' }}>
									<div className='tab' style={{ backgroundColor: '#40bedf', position: 'relative', cursor: 'pointer' }} onClick={() => setTab('Chasers')}>Note/Chase {getChaseActions().filter((item) => cases.case.details?.unviewActions.includes(item.id)).length > 0 && <div style={{ position: 'absolute', top: 0, right: 0, height: '16px', width: '16px', backgroundColor: 'red', borderRadius: '50%', color: '#FFFFFF', fontSize: '10px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>{getChaseActions().filter((item) => cases.case.details?.unviewActions.includes(item.id)).length}</div>}</div>

									<div className='tab' style={{ position: 'relative', cursor: 'pointer' }} onClick={() => setTab('Push')}>Why we Can't {getPushActions().filter((item) => cases.case.details?.unviewActions.includes(item.id)).length > 0 && <div style={{ position: 'absolute', top: 0, right: 0, height: '16px', width: '16px', backgroundColor: 'red', borderRadius: '50%', color: '#FFFFFF', fontSize: '10px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>{getPushActions().filter((item) => cases.case.details?.unviewActions.includes(item.id)).length}</div>}</div>

									<div className='tab' style={{ position: 'relative', cursor: 'pointer' }} onClick={() => setTab('Introducer')}>Introducer Actions {getIntroActions().filter((item) => cases.case.details?.unviewActions.includes(item.id)).length > 0 && <div style={{ position: 'absolute', top: 0, right: 0, height: '16px', width: '16px', backgroundColor: 'red', borderRadius: '50%', color: '#FFFFFF', fontSize: '10px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>{getIntroActions().filter((item) => cases.case.details?.unviewActions.includes(item.id)).length}</div>}</div>
								</div>
								<div style={{ borderBottom: '1px solid #F4941E', backgroundColor: 'white' }}>
									<div className="row100" style={{ alignItems: 'center', padding: '4px 0' }}>
										<div className="" style={{ display: 'flex', justifyContent: 'space-between', width: '15%', padding: '0 4px', fontFamily: 'OpenSans-SemiBold', fontSize: 13, overflow: 'hidden', textOverflow: 'ellipsis' }} onClick={() => actionOnClickCCE({ type: 'Raised' })}>
											<div>Raised</div>
											{cases.sortTypeCCE.type === 'Raised' && !cases.sortTypeCCE.reverse &&
												<FontAwesomeIcon style={{ fontSize: 18 }} icon={faCaretUp}></FontAwesomeIcon>
											}
											{cases.sortTypeCCE.type === 'Raised' && cases.sortTypeCCE.reverse &&
												<FontAwesomeIcon style={{ fontSize: 18 }} icon={faCaretDown}></FontAwesomeIcon>
											}
										</div>
										<div className="" style={{ display: 'flex', justifyContent: 'space-between', width: '10%', padding: '0 4px', fontFamily: 'OpenSans-SemiBold', fontSize: 13, overflow: 'hidden', textOverflow: 'ellipsis' }} onClick={() => actionOnClickCCE({ type: 'Type' })}>
											<div>Type</div>
											{cases.sortTypeCCE.type === 'Type' && !cases.sortTypeCCE.reverse &&
												<FontAwesomeIcon style={{ fontSize: 18 }} icon={faCaretUp}></FontAwesomeIcon>
											}
											{cases.sortTypeCCE.type === 'Type' && cases.sortTypeCCE.reverse &&
												<FontAwesomeIcon style={{ fontSize: 18 }} icon={faCaretDown}></FontAwesomeIcon>
											}
										</div>
										<div className="" style={{ display: 'flex', justifyContent: 'space-between', width: '10%', padding: '0 4px', fontFamily: 'OpenSans-SemiBold', fontSize: 13, overflow: 'hidden', textOverflow: 'ellipsis' }} onClick={() => actionOnClickCCE({ type: 'Who' })}>
											<div>Who?</div>
											{cases.sortTypeCCE.type === 'Who' && !cases.sortTypeCCE.reverse &&
												<FontAwesomeIcon style={{ fontSize: 18 }} icon={faCaretUp}></FontAwesomeIcon>
											}
											{cases.sortTypeCCE.type === 'Who' && cases.sortTypeCCE.reverse &&
												<FontAwesomeIcon style={{ fontSize: 18 }} icon={faCaretDown}></FontAwesomeIcon>
											}
										</div>
										<div className="" style={{ display: 'flex', justifyContent: 'space-between', width: '10%', padding: '0 4px', fontFamily: 'OpenSans-SemiBold', fontSize: 13, overflow: 'hidden', textOverflow: 'ellipsis' }} onClick={() => actionOnClickCCE({ type: 'Why' })}>
											<div>Why?</div>
											{cases.sortTypeCCE.type === 'Why' && !cases.sortTypeCCE.reverse &&
												<FontAwesomeIcon style={{ fontSize: 18 }} icon={faCaretUp}></FontAwesomeIcon>
											}
											{cases.sortTypeCCE.type === 'Why' && cases.sortTypeCCE.reverse &&
												<FontAwesomeIcon style={{ fontSize: 18 }} icon={faCaretDown}></FontAwesomeIcon>
											}
										</div>
										<div className="" style={{ display: 'flex', justifyContent: 'space-between', width: '17%', padding: '0 4px', fontFamily: 'OpenSans-SemiBold', fontSize: 13, overflow: 'hidden', textOverflow: 'ellipsis' }} onClick={() => actionOnClickCCE({ type: 'Responded' })}>
											<div>Responded</div>
											{cases.sortTypeCCE.type === 'Responded' && !cases.sortTypeCCE.reverse &&
												<FontAwesomeIcon style={{ fontSize: 18 }} icon={faCaretUp}></FontAwesomeIcon>
											}
											{cases.sortTypeCCE.type === 'Responded' && cases.sortTypeCCE.reverse &&
												<FontAwesomeIcon style={{ fontSize: 18 }} icon={faCaretDown}></FontAwesomeIcon>
											}
										</div>
										<div className="" style={{ display: 'flex', justifyContent: 'space-between', width: '17%', padding: '0 4px', fontFamily: 'OpenSans-SemiBold', fontSize: 13, overflow: 'hidden', textOverflow: 'ellipsis' }} onClick={() => actionOnClickCCE({ type: 'Response' })}>
											<div>Response</div>
											{cases.sortTypeCCE.type === 'Response' && !cases.sortTypeCCE.reverse &&
												<FontAwesomeIcon style={{ fontSize: 18 }} icon={faCaretUp}></FontAwesomeIcon>
											}
											{cases.sortTypeCCE.type === 'Response' && cases.sortTypeCCE.reverse &&
												<FontAwesomeIcon style={{ fontSize: 18 }} icon={faCaretDown}></FontAwesomeIcon>
											}
										</div>
										<div className="" style={{ display: 'flex', justifyContent: 'space-between', width: '6%', padding: '0 4px', fontFamily: 'OpenSans-SemiBold', fontSize: 13, overflow: 'hidden', textOverflow: 'ellipsis' }} onClick={() => actionOnClickCCE({ type: 'Status' })}>
											<div>Status</div>
											{cases.sortTypeCCE.type === 'Status' && !cases.sortTypeCCE.reverse &&
												<FontAwesomeIcon style={{ fontSize: 18 }} icon={faCaretUp}></FontAwesomeIcon>
											}
											{cases.sortTypeCCE.type === 'Status' && cases.sortTypeCCE.reverse &&
												<FontAwesomeIcon style={{ fontSize: 18 }} icon={faCaretDown}></FontAwesomeIcon>
											}
										</div>
										<div className='actionButton' style={{ display: 'flex', justifyContent: 'flex-start', width: '15%', padding: '0 4px', fontFamily: 'OpenSans-SemiBold', fontSize: 13, overflow: 'hidden', textOverflow: 'ellipsis' }} >
											<div>Actions</div>
										</div>
									</div>
								</div>
							</div>
							<div className={`actionTableContent ${isMac ? 'macOverflow' : ''}`} style={{ position: 'absolute', top: 555, bottom: 0, left: '2%', right: 0, overflowY: 'scroll' }} onScroll={handleScroll}>
								{(getChaseActions() || []).map((item: Cases.caseActionsState) => {
									return (
										<div className="row100 hover" key={item.id} style={{ fontSize: 13, padding: "4px 0" }}>
											<div className="" style={{ width: '15%', padding: '0 4px', overflow: 'hidden', textOverflow: 'ellipsis' }}>{getUkDate(item.raised)}</div>
											<div className="" style={{ width: '10%', padding: '0 4px', overflow: 'hidden', textOverflow: 'ellipsis' }}>{item.type}</div>
											<div className="" style={{ width: '10%', padding: '0 4px', overflow: 'hidden', textTransform: 'capitalize', textOverflow: 'ellipsis' }}>{item.reason}</div>
											<div className="" style={{ width: '10%', padding: '0 4px', overflow: 'hidden', textOverflow: 'ellipsis' }}>{item.notes}</div>
											<div className="" style={{ width: '17%', padding: '0 4px', overflow: 'hidden', textOverflow: 'ellipsis' }}>{getUkDate(item.responded)}</div>
											<div className="" style={{ width: '17%', padding: '0 4px', overflow: 'hidden', textOverflow: 'ellipsis' }}>{item.response}</div>
											<div className="" style={{ width: '6%', padding: '0 4px', overflow: 'hidden' }}>
												{item.responded === '1900-01-01 00:00:00.000' &&
													<FontAwesomeIcon style={{ fontSize: 24, color: 'orange' }} icon={faTriangleExclamation} />
												}
												{item.responded !== '1900-01-01 00:00:00.000' &&
													<FontAwesomeIcon style={{ fontSize: 24, color: 'green' }} icon={faCircleCheck} />
												}
											</div>
											<div className='actionButton' style={{ width: '15%', padding: '0 4px', overflow: 'hidden', textOverflow: 'ellipsis', display: 'flex', alignItems: 'center' }}>
												{cases.case.details?.unviewActions?.includes(item?.id) ? <div className="markAsReadBtn" onClick={() => handleMarkAsRead(item?.id)}>Mark as Read</div> : <p style={{ height: '30px', margin: '0px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>{getUkDate(item?.readDate)}</p>}
											</div>
										</div>
									)
								})}
							</div>
						</>
					}
					{page === 'Push' &&
						<div id='PUSH' style={{ flexGrow: 1, marginLeft: 64 }}>
							<div style={{ display: 'flex', margin: 4, justifyContent: 'flex-start' }}>
								<div style={{ display: 'flex', alignItems: 'center', fontSize: 15, fontFamily: 'OpenSans-Bold' }}>
									<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Ask PLS why we Can’t...</div>
								</div>
							</div>
							<div style={{ display: 'flex', margin: 4, fontSize: 13, alignItems: 'top' }}>
								<div className='row25' style={{ display: 'flex', alignItems: 'top', justifyContent: 'start' }}></div>
								<div className='row75'>
									<select data-form-id={'PUSH'} data-valid-type="*" className={getFormValidWithId('PUSH', "push_reason") ? undefined : 'error'} value={getFormValueWithId('PUSH', "push_reason")} name='push_reason' id='push_reason' onChange={(e) => doFormOnChange(e)}>
										<option value=''>Please Select...</option>
										{(getActions('PUSH') || []).map((item: Cases.actionItemState) => {
											return (
												<option key={item.reasoncode} value={item.reasoncode}> {item.reason} ({item.reasoncode})</option>
											)
										})}
									</select>
								</div>
							</div>
							<div style={{ display: 'flex', margin: 4 }}>
								<div className='row25'></div>
								<div className='row75' style={{ display: 'inherit' }}>
									<div className='buttonGreen' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden' }} onClick={() => pushCase()}>
										<div style={{ display: 'flex' }}>
											<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden', marginLeft: 24 }}>Ask PLS...</div>
										</div>
										<div style={{ width: 32, display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
											{cases.isPushing &&
												<FontAwesomeIcon className='fa-spin' style={{ fontSize: 18, marginRight: 8 }} icon={faSync} />
											}
										</div>
									</div>
								</div>
							</div>
						</div>
					}
					{tab === 'Push' &&
						<>
							<div style={{ position: 'absolute', top: 468, left: '2%', right: 0, height: 80, display: 'flex', flexDirection: 'column', gap: '10px', paddingRight: '15px' }}>
								<div style={{ display: 'flex' }}>
									<div className='tab' style={{ position: 'relative', cursor: 'pointer' }} onClick={() => setTab('Chasers')}>Note/Chase {getChaseActions().filter((item) => cases.case.details?.unviewActions.includes(item.id)).length > 0 && <div style={{ position: 'absolute', top: 0, right: 0, height: '16px', width: '16px', backgroundColor: 'red', borderRadius: '50%', color: '#FFFFFF', fontSize: '10px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>{getChaseActions().filter((item) => cases.case.details?.unviewActions.includes(item.id)).length}</div>}</div>

									<div className='tab' style={{ backgroundColor: '#40bedf', position: 'relative', cursor: 'pointer' }} onClick={() => setTab('Push')}>Why we Can't {getPushActions().filter((item) => cases.case.details?.unviewActions.includes(item.id)).length > 0 && <div style={{ position: 'absolute', top: 0, right: 0, height: '16px', width: '16px', backgroundColor: 'red', borderRadius: '50%', color: '#FFFFFF', fontSize: '10px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>{getPushActions().filter((item) => cases.case.details?.unviewActions.includes(item.id)).length}</div>}</div>

									<div className='tab' style={{ position: 'relative', cursor: 'pointer' }} onClick={() => setTab('Introducer')}>Introducer Actions {getIntroActions().filter((item) => cases.case.details?.unviewActions.includes(item.id)).length > 0 && <div style={{ position: 'absolute', top: 0, right: 0, height: '16px', width: '16px', backgroundColor: 'red', borderRadius: '50%', color: '#FFFFFF', fontSize: '10px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>{getIntroActions().filter((item) => cases.case.details?.unviewActions.includes(item.id)).length}</div>}</div>
								</div>
								<div style={{ borderBottom: '1px solid #F4941E', backgroundColor: 'white' }}>
									<div className="row100" style={{ alignItems: 'center', padding: '4px 0' }}>
										<div className="" style={{ display: 'flex', justifyContent: 'space-between', padding: '0 4px', fontFamily: 'OpenSans-SemiBold', fontSize: 13, overflow: 'hidden', textOverflow: 'ellipsis', width: '15%' }} onClick={() => actionOnClickWWC({ type: 'Raised' })}>
											<div>Raised</div>
											{cases.sortTypeWWC.type === 'Raised' && !cases.sortTypeWWC.reverse &&
												<FontAwesomeIcon style={{ fontSize: 18 }} icon={faCaretUp}></FontAwesomeIcon>
											}
											{cases.sortTypeWWC.type === 'Raised' && cases.sortTypeWWC.reverse &&
												<FontAwesomeIcon style={{ fontSize: 18 }} icon={faCaretDown}></FontAwesomeIcon>
											}
										</div>
										<div className="" style={{ display: 'flex', justifyContent: 'space-between', padding: '0 4px', fontFamily: 'OpenSans-SemiBold', fontSize: 13, overflow: 'hidden', textOverflow: 'ellipsis', width: '15%' }} onClick={() => actionOnClickWWC({ type: 'Why' })}>
											<div>Why?</div>
											{cases.sortTypeWWC.type === 'Why' && !cases.sortTypeWWC.reverse &&
												<FontAwesomeIcon style={{ fontSize: 18 }} icon={faCaretUp}></FontAwesomeIcon>
											}
											{cases.sortTypeWWC.type === 'Why' && cases.sortTypeWWC.reverse &&
												<FontAwesomeIcon style={{ fontSize: 18 }} icon={faCaretDown}></FontAwesomeIcon>
											}
										</div>
										<div className="" style={{ display: 'flex', justifyContent: 'space-between', padding: '0 4px', fontFamily: 'OpenSans-SemiBold', fontSize: 13, overflow: 'hidden', textOverflow: 'ellipsis', width: '15%' }} onClick={() => actionOnClickWWC({ type: 'Responded' })}>
											<div>Responded</div>
											{cases.sortTypeWWC.type === 'Responded' && !cases.sortTypeWWC.reverse &&
												<FontAwesomeIcon style={{ fontSize: 18 }} icon={faCaretUp}></FontAwesomeIcon>
											}
											{cases.sortTypeWWC.type === 'Responded' && cases.sortTypeWWC.reverse &&
												<FontAwesomeIcon style={{ fontSize: 18 }} icon={faCaretDown}></FontAwesomeIcon>
											}
										</div>
										<div className="" style={{ display: 'flex', justifyContent: 'space-between', padding: '0 4px', fontFamily: 'OpenSans-SemiBold', fontSize: 13, overflow: 'hidden', textOverflow: 'ellipsis', width: '20%' }} onClick={() => actionOnClickWWC({ type: 'Response' })}>
											<div>Response</div>
											{cases.sortTypeWWC.type === 'Response' && !cases.sortTypeWWC.reverse &&
												<FontAwesomeIcon style={{ fontSize: 18 }} icon={faCaretUp}></FontAwesomeIcon>
											}
											{cases.sortTypeWWC.type === 'Response' && cases.sortTypeWWC.reverse &&
												<FontAwesomeIcon style={{ fontSize: 18 }} icon={faCaretDown}></FontAwesomeIcon>
											}
										</div>
										<div className="" style={{ display: 'flex', justifyContent: 'space-between', padding: '0 4px', fontFamily: 'OpenSans-SemiBold', fontSize: 13, overflow: 'hidden', textOverflow: 'ellipsis', width: '15%' }} onClick={() => actionOnClickWWC({ type: 'Status' })}>
											<div>Status</div>
											{cases.sortTypeWWC.type === 'Status' && !cases.sortTypeWWC.reverse &&
												<FontAwesomeIcon style={{ fontSize: 18 }} icon={faCaretUp}></FontAwesomeIcon>
											}
											{cases.sortTypeWWC.type === 'Status' && cases.sortTypeWWC.reverse &&
												<FontAwesomeIcon style={{ fontSize: 18 }} icon={faCaretDown}></FontAwesomeIcon>
											}
										</div>
										<div className="" style={{ display: 'flex', justifyContent: 'flex-start', padding: '0 4px', fontFamily: 'OpenSans-SemiBold', fontSize: 13, overflow: 'hidden', textOverflow: 'ellipsis', width: '20%' }} >
											<div>Actions</div>
										</div>
									</div>
								</div>
							</div>
							<div className={`actionTableContent ${isMac ? 'macOverflow' : ''}`} style={{ position: 'absolute', top: 555, bottom: 0, left: '2%', right: 0, overflowY: 'scroll' }} onScroll={handleScroll}>
								{(getPushActions() || []).map((item: Cases.caseActionsState) => {
									return (
										<div className="hover" style={{ padding: '4px 0', fontSize: 13 }}>
											<div className="row100 hover" key={item.id}>
												<div className="" style={{ padding: '0 4px', overflow: 'hidden', textOverflow: 'ellipsis', width: '15%' }}>{getUkDate(item.raised)}</div>
												<div className="" style={{ padding: '0 4px', overflow: 'hidden', textOverflow: 'ellipsis', width: '15%' }}>{item.notes}</div>
												<div className="" style={{ padding: '0 4px', overflow: 'hidden', textOverflow: 'ellipsis', width: '15%' }}>{getUkDate(item.responded)}</div>
												<div className="" style={{ padding: '0 4px', overflow: 'hidden', textOverflow: 'ellipsis', width: '20%' }}>{item.response}</div>
												<div className="" style={{ padding: '0 4px', overflow: 'hidden', textOverflow: 'ellipsis', width: '15%' }}>
													{item.responded === '1900-01-01 00:00:00.000' &&
														<FontAwesomeIcon style={{ fontSize: 24, color: 'orange' }} icon={faTriangleExclamation} />
													}
													{item.responded !== '1900-01-01 00:00:00.000' &&
														<FontAwesomeIcon style={{ fontSize: 24, color: 'green' }} icon={faCircleCheck} />
													}
												</div>
												<div style={{padding: '0 4px', overflow: 'hidden', textOverflow: 'ellipsis', width: '20%', display: 'flex', alignItems: 'center' }}>
													{cases.case.details?.unviewActions?.includes(item?.id) ? <div className="markAsReadBtn" onClick={() => handleMarkAsRead(item?.id)}>Mark as Read</div> : <p style={{ height: '30px', margin: '0px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>{getUkDate(item?.readDate)}</p>}
												</div>
											</div>
										</div>
									)
								})}
							</div>
						</>
					}
					{page === 'Introducer' &&
						<div id='INTRO' style={{ flexGrow: 1, marginLeft: 64 }}>
							<div style={{ display: 'flex', margin: 4, justifyContent: 'flex-start' }}>
								<div style={{ display: 'flex', alignItems: 'center', fontSize: 15, fontFamily: 'OpenSans-Bold' }}>
									<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>
										{getIntroActions().length > 0 ? !cases.case.selectedAction ? "Please select an action to respond to..." :
											"" : "No Introducer action required"}
									</div>
								</div>
							</div>
							{cases.case.selectedAction &&
								<div>
									<div style={{ display: 'flex', margin: 4, fontSize: 13, alignItems: 'top' }}>
										<div className='row100' style={{ fontFamily: 'OpenSans-Bold', fontSize: 13 }}>
											{cases.case.selectedAction.reason} ({cases.case.selectedAction.notes})
										</div>
									</div>
									<div style={{ display: 'flex', margin: 4, fontSize: 13, alignItems: 'top' }}>
										<div className='row25' style={{ display: 'flex', alignItems: 'top', justifyContent: 'start' }}>Response:</div>
										<div className='row75'>
											<textarea data-form-id={'INTRO'} rows={4} data-valid-type="*" className={getFormValidWithId('INTRO', "intro_response") ? undefined : 'error'} value={getFormValueWithId('INTRO', "intro_response")} name='intro_response' id='intro_response' onChange={(e) => doFormOnChange(e)} />
										</div>
									</div>
									<div style={{ display: 'flex', margin: 4 }}>
										<div className='row25'></div>
										<div className='row75' style={{ display: 'inherit' }}>
											<div className='buttonGreen' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflow: 'hidden' }} onClick={() => sendIntroAction()}>
												<div style={{ display: 'flex' }}>
													<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden', marginLeft: 24, cursor: 'pointer' }}>Submit</div>
												</div>
												<div style={{ width: 32, display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
													{cases.isSendingIntroResponse &&
														<FontAwesomeIcon className='fa-spin' style={{ fontSize: 18, marginRight: 8 }} icon={faSync} />
													}
												</div>
											</div>
										</div>
									</div>
								</div>
							}
						</div>
					}
					{tab === 'Introducer' &&
						<>
							<div style={{ position: 'absolute', top: 468, left: '2%', right: 0, height: 80,display: 'flex', flexDirection: 'column', gap: '10px', paddingRight: '15px' }}>
								<div style={{ display: 'flex' }}>
									<div className='tab' style={{ position: 'relative', cursor: 'pointer' }} onClick={() => setTab('Chasers')}>Note/Chase {getChaseActions().filter((item) => cases.case.details?.unviewActions.includes(item.id)).length > 0 && <div style={{ position: 'absolute', top: 0, right: 0, height: '16px', width: '16px', backgroundColor: 'red', borderRadius: '50%', color: '#FFFFFF', fontSize: '10px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>{getChaseActions().filter((item) => cases.case.details?.unviewActions.includes(item.id)).length}</div>}</div>

									<div className='tab' style={{ position: 'relative', cursor: 'pointer' }} onClick={() => setTab('Push')}>Why we Can't {getPushActions().filter((item) => cases.case.details?.unviewActions.includes(item.id)).length > 0 && <div style={{ position: 'absolute', top: 0, right: 0, height: '16px', width: '16px', backgroundColor: 'red', borderRadius: '50%', color: '#FFFFFF', fontSize: '10px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>{getPushActions().filter((item) => cases.case.details?.unviewActions.includes(item.id)).length}</div>}</div>

									<div className='tab' style={{ backgroundColor: '#40bedf', position: 'relative', cursor: 'pointer' }} onClick={() => setTab('Introducer')}>Introducer Actions {getIntroActions().filter((item) => cases.case.details?.unviewActions.includes(item.id)).length > 0 && <div style={{ position: 'absolute', top: 0, right: 0, height: '16px', width: '16px', backgroundColor: 'red', borderRadius: '50%', color: '#FFFFFF', fontSize: '10px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>{getIntroActions().filter((item) => cases.case.details?.unviewActions.includes(item.id)).length}</div>}</div>
								</div>
								<div style={{ borderBottom: '1px solid #F4941E', backgroundColor: 'white' }}>
									<div className="row100" style={{ alignItems: 'center', padding: '4px 0' }}>
										<div className="" style={{ display: 'flex', justifyContent: 'space-between', padding: '0 4px', fontFamily: 'OpenSans-SemiBold', fontSize: 13, overflow: 'hidden', textOverflow: 'ellipsis', width: '12%' }} onClick={() => actionOnClickIA({ type: 'Raised' })}>
											<div>Raised</div>
											{cases.sortTypeIA.type === 'Raised' && !cases.sortTypeIA.reverse &&
												<FontAwesomeIcon style={{ fontSize: 18 }} icon={faCaretUp}></FontAwesomeIcon>
											}
											{cases.sortTypeIA.type === 'Raised' && cases.sortTypeIA.reverse &&
												<FontAwesomeIcon style={{ fontSize: 18 }} icon={faCaretDown}></FontAwesomeIcon>
											}
										</div>
										<div className="" style={{ display: 'flex', justifyContent: 'space-between', padding: '0 4px', fontFamily: 'OpenSans-SemiBold', fontSize: 13, overflow: 'hidden', textOverflow: 'ellipsis', width: '13%' }} onClick={() => actionOnClickIA({ type: 'Who' })}>
											<div>Who?</div>
											{cases.sortTypeIA.type === 'Who' && !cases.sortTypeIA.reverse &&
												<FontAwesomeIcon style={{ fontSize: 18 }} icon={faCaretUp}></FontAwesomeIcon>
											}
											{cases.sortTypeIA.type === 'Who' && cases.sortTypeIA.reverse &&
												<FontAwesomeIcon style={{ fontSize: 18 }} icon={faCaretDown}></FontAwesomeIcon>
											}
										</div>
										<div className="" style={{ display: 'flex', justifyContent: 'space-between', padding: '0 4px', fontFamily: 'OpenSans-SemiBold', fontSize: 13, overflow: 'hidden', textOverflow: 'ellipsis', width: '15%' }} onClick={() => actionOnClickIA({ type: 'Why' })}>
											<div>Why?</div>
											{cases.sortTypeIA.type === 'Why' && !cases.sortTypeIA.reverse &&
												<FontAwesomeIcon style={{ fontSize: 18 }} icon={faCaretUp}></FontAwesomeIcon>
											}
											{cases.sortTypeIA.type === 'Why' && cases.sortTypeIA.reverse &&
												<FontAwesomeIcon style={{ fontSize: 18 }} icon={faCaretDown}></FontAwesomeIcon>
											}
										</div>
										<div className="" style={{ display: 'flex', justifyContent: 'space-between', padding: '0 4px', fontFamily: 'OpenSans-SemiBold', fontSize: 13, overflow: 'hidden', textOverflow: 'ellipsis', width: '15%' }} onClick={() => actionOnClickIA({ type: 'Responded' })}>
											<div>Responded</div>
											{cases.sortTypeIA.type === 'Responded' && !cases.sortTypeIA.reverse &&
												<FontAwesomeIcon style={{ fontSize: 18 }} icon={faCaretUp}></FontAwesomeIcon>
											}
											{cases.sortTypeIA.type === 'Responded' && cases.sortTypeIA.reverse &&
												<FontAwesomeIcon style={{ fontSize: 18 }} icon={faCaretDown}></FontAwesomeIcon>
											}
										</div>
										<div className="" style={{ display: 'flex', justifyContent: 'space-between', padding: '0 4px', fontFamily: 'OpenSans-SemiBold', fontSize: 13, overflow: 'hidden', textOverflow: 'ellipsis', width: '20%' }} onClick={() => actionOnClickIA({ type: 'Response' })}>
											<div>Response</div>
											{cases.sortTypeIA.type === 'Response' && !cases.sortTypeIA.reverse &&
												<FontAwesomeIcon style={{ fontSize: 18 }} icon={faCaretUp}></FontAwesomeIcon>
											}
											{cases.sortTypeIA.type === 'Response' && cases.sortTypeIA.reverse &&
												<FontAwesomeIcon style={{ fontSize: 18 }} icon={faCaretDown}></FontAwesomeIcon>
											}
										</div>
										<div className="" style={{ display: 'flex', justifyContent: 'space-between', padding: '0 4px', fontFamily: 'OpenSans-SemiBold', fontSize: 13, overflow: 'hidden', textOverflow: 'ellipsis', width: '10%' }} onClick={() => actionOnClickIA({ type: 'Status' })}>
											<div>Status</div>
											{cases.sortTypeIA.type === 'Status' && !cases.sortTypeIA.reverse &&
												<FontAwesomeIcon style={{ fontSize: 18 }} icon={faCaretUp}></FontAwesomeIcon>
											}
											{cases.sortTypeIA.type === 'Status' && cases.sortTypeIA.reverse &&
												<FontAwesomeIcon style={{ fontSize: 18 }} icon={faCaretDown}></FontAwesomeIcon>
											}
										</div>
										<div style={{ display: 'flex', justifyContent: 'flex-start', width: '15%', padding: '0 4px', fontFamily: 'OpenSans-SemiBold', fontSize: 13, overflow: 'hidden', textOverflow: 'ellipsis' }} >
											<div>Actions</div>
										</div>
									</div>
								</div>
							</div>
							<div className={`actionTableContent ${isMac ? 'macOverflow' : ''}`} style={{ position: 'absolute', top: 555, left: '2%', right: "0px", bottom: 0, overflowY: 'scroll' }} onScroll={handleScroll}>
								{(getIntroActions() || []).map((item: Cases.caseActionsState) => {
									return (
										<div className="hover" style={{ padding: '4px 0', fontSize: 13 }} onClick={() => selectIntroAction(item)}>
											<div className="row100 hover" key={item.id}>
												<div className="" style={{ padding: '0 4px', overflow: 'hidden', textOverflow: 'ellipsis', width: '12%' }}>{getUkDate(item.raised)}</div>
												<div className="" style={{ padding: '0 4px', overflow: 'hidden', textTransform: 'capitalize', textOverflow: 'ellipsis', width:'13%' }}>{item.reason}</div>
												<div className="" style={{ padding: '0 4px', overflow: 'hidden', textOverflow: 'ellipsis', width: '15%' }}>{item.notes}</div>
												<div className="" style={{ padding: '0 4px', overflow: 'hidden', textOverflow: 'ellipsis', width: '15%' }}>{getUkDate(item.responded)}</div>
												<div className="" style={{ padding: '0 4px', overflow: 'hidden', textOverflow: 'ellipsis', width:'20%' }}>{item.response}</div>
												<div className="" style={{ padding: '0 4px', overflow: 'hidden', width: '10%', display: 'flex', alignItems: 'center' }}>
													{item.responded === '1900-01-01 00:00:00.000' &&
														<FontAwesomeIcon style={{ fontSize: 24, color: 'orange' }} icon={faTriangleExclamation} />
													}
													{item.responded !== '1900-01-01 00:00:00.000' &&
														<FontAwesomeIcon style={{ fontSize: 24, color: 'green' }} icon={faCircleCheck} />
													}
												</div>
												<div style={{ width: '15%', padding: '0 4px', overflow: 'hidden', textOverflow: 'ellipsis', display: 'flex', alignItems: 'center' }}>
													{cases.case.details?.unviewActions?.includes(item?.id) ? <div className="markAsReadBtn" onClick={() => handleMarkAsRead(item?.id)}>Mark as Read</div> : <p style={{ height: '30px', margin: '0px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>{getUkDate(item?.readDate)}</p>}
												</div>
											</div>
										</div>
									)
								})}
							</div>
						</>
					}
				</div>
			</div>

			<div className='mainFooter'>
				<div style={{ marginLeft: '10%', marginRight: '10%', width: '80%', marginTop: 18 }}>
					<img style={{ height: 28 }} src={leading_the_way} alt='LeadingTheWay-Banner' />
				</div>
			</div>
			<div className='loginFooter'></div>
			<NavMenu />
			<NavBar />
		</div>
	);
}

export default Actions;